/**
 * Created by zad on 17/4/25.
 */
import { Notebooks } from '../constants/actionTypes';
import createAction from '../utils/createAction';

// eslint-disable-next-line import/prefer-default-export
export const getNotebooks = createAction(Notebooks.GET_NOTEBOOKS, 'isForce');

export const sortNotebooks = createAction(Notebooks.SORT_NOTEBOOKS, 'oldSeq', 'newSeq');

export const newNotebook = createAction(Notebooks.NEW_NOTEBOOK, 'name');

export const deleteNotebookSoft = createAction(Notebooks.DEL_NOTEBOOK_SOFT, 'nbId');

export const renameNotebook = createAction(Notebooks.RENAME_NOTEBOOK, 'nbId', 'name');



// WEBPACK FOOTER //
// ./src/actions/NotebooksAction.js